import styled from 'styled-components';
import { useIsLabsFeatureEnabled } from '@frameio/shared/hooks';
import { theme as vaporTheme, useThemeName } from '@frameio/vapor';
import { getFolderColorMix } from '../constants/folderColors';
import { useFolderColor } from '../hooks/useFolderColor';
import { RestrictedFolderIcon } from './RestrictedFolderIcon';

type Props = {
  folderId?: string;
  isRestricted: boolean;
};

export const WIDTH = 34;

export const ListFolderThumb = ({ folderId, isRestricted }: Props) => {
  const theme = useThemeName();
  const isLight = theme === 'light' || theme === 'light-accentNeutral';
  const isColoredFolders = useIsLabsFeatureEnabled('folder_colors');
  const { colorToken } = useFolderColor(folderId ?? '');
  const folderColor =
    isColoredFolders && colorToken
      ? getFolderColorMix(colorToken, isLight)
      : undefined;

  return (
    <div
      style={{
        display: `flex`,
        justifyContent: `center`,
        alignContent: `center`,
        flexDirection: `column`,
        height: 40,
      }}
    >
      <div
        // Anchors the Quicklook open/close animation to the folder thumbnail
        // (list folders don't use the shared thumbnail wrapper).
        data-role-quicklook="true"
        style={{
          width: WIDTH,
          height: 25,
          position: `relative`,
          top: -1,
        }}
      >
        <svg
          fill="none"
          height="25"
          viewBox="0 0 34 25"
          width={WIDTH}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 21.8384V2.83838C0 1.73381 0.89543 0.838379 2 0.838379H8.34621C9.60456 0.838379 10.8342 1.21446 11.8772 1.91835C12.9203 2.62224 14.1499 2.99833 15.4083 2.99833H32C33.1046 2.99833 34 3.89376 34 4.99833V21.8384C34 23.4952 32.6569 24.8384 31 24.8384H3C1.34315 24.8384 0 23.4952 0 21.8384Z"
            fill={
              folderColor ??
              vaporTheme.colors.components.folder.header.background
            }
          />
          <path
            d="M0.5 21.8384V2.83838C0.5 2.00995 1.17157 1.33838 2 1.33838H8.34621C9.50488 1.33838 10.6371 1.68467 11.5976 2.33281C12.7232 3.09245 14.0503 3.49833 15.4083 3.49833H32C32.8284 3.49833 33.5 4.1699 33.5 4.99833V21.8384C33.5 23.2191 32.3807 24.3384 31 24.3384H3C1.61929 24.3384 0.5 23.2191 0.5 21.8384Z"
            stroke="white"
            strokeOpacity="0.02"
          />
        </svg>
        <Div $folderColor={folderColor} $isLight={isLight} />

        {isRestricted && (
          <RestrictedFolderIcon
            bottom="-9px"
            position="absolute"
            right="-6px"
          />
        )}
      </div>
    </div>
  );
};

const Div = styled.div<{ $isLight: boolean; $folderColor?: string }>`
  background: ${(p) =>
    p.$folderColor ?? vaporTheme.colors.components.folder.header.background};
  border: 0.5px solid rgba(255, 255, 255, 0.04);

  border-radius: 2px;
  bottom: 0%;
  box-shadow: ${vaporTheme.card.folder};
  box-sizing: border-box;
  left: 0%;

  position: absolute;
  right: 0%;
  top: 25%;
  width: ${WIDTH}px;
`;
